import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';
import commonStyles from '@styles/common.module.css';

export const LOCATIONS = {
  TOP: 'top',
  LEFT: 'left',
};

function Block(props) {
  return (
    <section
      className={`${styles.block} ${props.className ? props.className : ''} ${
        styles[`location_${props.location}`]
      }`}>
      {props.header && (
        <header className={`${styles.header} ${commonStyles.font}`}>
          {props.header}
        </header>
      )}
      <div className={`${styles.content} ${commonStyles.font}`}>
        {props.children}
      </div>
    </section>
  );
}

Block.defaultProps = {
  location: LOCATIONS.LEFT,
  header: '',
};

Block.propTypes = {
  location: PropTypes.string,
  header: PropTypes.string,
};

export default Block;
